/* eslint-disable camelcase */
import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { get } from 'lodash';
import { toast } from 'react-toastify';
import { Button, Box } from '@mui/material';
import { FaArrowsRotate } from 'react-icons/fa6';
import { parse, format, parseISO } from 'date-fns';
import { ContainerGrid, Title } from '../../styles/GlobalStyles';
import axios from '../../services/axios';
import Loading from '../../components/Loading';
import DataTable from '../../components/DataTableViewNoAction';
import APIDocumentation from '../APIDocumentation';

const textData = 'Integração';
const tableRoute = 'integration';
const tableData = 'integration';

export default function Integracao() {
  const [table, setTable] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const getData = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`/${tableData}`);
      setTable(response.data.integrations || []);
    } catch (err) {
      const status = get(err, 'response.status', 0);
      const errors = get(err, 'response.data.errors', []);

      if (status === 400) errors.map((error) => toast.error(error));
      navigate(`/home`);
    } finally {
      setIsLoading(false);
    }
  }, [navigate]); // Dependências de useCallback

  useEffect(() => {
    getData();
  }, [getData]); // Adicione getData ao array de dependências

  const columns = useMemo(
    () => [
      {
        accessorKey: 'id', // access nested data with dot notation
        header: 'ID',
        size: 80,
      },
      {
        accessorKey: 'processed',
        header: 'Processado',
        accessorFn: (row) => {
          const actionTypeMap = {
            0: 'Não',
            1: 'Sim',
            2: 'Erro',
          };
          return actionTypeMap[row.processed] || 'N/A';
        },
        size: 3,
        muiTableBodyCellProps: ({ cell }) => ({
          sx: {
            color:
              cell.getValue() === 'Erro' || cell.getValue() === 'Não'
                ? 'red'
                : 'black', // Vermelho para 'Erro' ou 'Não', preto para outros
            fontWeight:
              cell.getValue() === 'Erro' || cell.getValue() === 'Não'
                ? 'bold'
                : 'normal', // Negrito para 'Erro' ou 'Não'
          },
        }),
      },
      {
        accessorKey: 'created_at',
        accessorFn: (row) => {
          if (!row.created_at) return null; // Retorna null se não houver data

          try {
            return format(parseISO(row.created_at), 'dd/MM/yyyy'); // Formata para DD/MM/YYYY
          } catch (error) {
            return null; // Retorna null em caso de erro
          }
        },
        header: 'Data Envio',
        size: 80,
      },
      {
        accessorKey: 'nrordemcoleta',
        header: 'Nr. Ordem Coleta',
        size: 80,
      },
      {
        accessorKey: 'data',
        accessorFn: (row) => {
          if (!row.data) return null; // Retorna null se não houver data

          try {
            return format(parseISO(row.data), 'dd/MM/yyyy'); // Formata para DD/MM/YYYY
          } catch (error) {
            return null; // Retorna null em caso de erro
          }
        },
        header: 'Data Coleta',
        size: 80,
      },
      {
        accessorKey: 'hora',
        accessorFn: (row) => {
          if (!row.hora) return null;

          return format(parse(row.hora, 'HH:mm:ss', new Date()), 'HH:mm:ss');
        },
        header: 'Hora Coleta',
        size: 80,
      },
      {
        accessorKey: 'empresa',
        header: 'Empresa',
        size: 80,
      },
      {
        accessorKey: 'cliente',
        header: 'Cliente',
        size: 80,
      },
      {
        accessorKey: 'funcionario',
        header: 'Funcionário',
        size: 80,
      },
      {
        accessorKey: 'motorista',
        header: 'Motorista',
        size: 80,
      },
      {
        accessorKey: 'placaveiculo',
        header: 'Placa Veículo',
        size: 80,
      },
      {
        accessorKey: 'placacarreta',
        header: 'Placa Carreta',
        size: 80,
      },
      {
        accessorKey: 'vlfrete',
        header: 'Valor Frete',
        size: 80,
      },
      {
        accessorKey: 'vlpeso',
        header: 'Peso',
        size: 80,
      },
      {
        accessorKey: 'localsaida',
        header: 'Saida',
        size: 80,
      },
      {
        accessorKey: 'localdestino',
        header: 'Destino',
        size: 80,
      },
      {
        accessorKey: 'observacao',
        header: 'Observação',
        size: 80,
      },
      {
        accessorKey: 'requisicao',
        header: 'Requisição',
        size: 80,
      },
      {
        accessorKey: 'message',
        header: 'Mensagem',
        size: 100,
      },
    ],
    []
  );

  return (
    <ContainerGrid>
      <Title>{`${textData}`}</Title>
      <Box sx={{ display: 'flex', justifyContent: 'Right' }}>
        <Button
          type="button"
          color="secondary"
          variant="contained"
          style={{ marginLeft: '5px' }}
          onClick={getData} // Chama a função getData diretamente
        >
          <FaArrowsRotate />
        </Button>
        <Button
          type="button"
          color="secondary"
          variant="contained"
          style={{ marginLeft: '5px' }}
          onClick={() => navigate(`/home`)}
        >
          Fechar
        </Button>
      </Box>
      <div>
        <DataTable
          columns={columns}
          data={table}
          tableData={tableData}
          tableRoute={tableRoute}
        />
      </div>
      <div>
        <APIDocumentation />
      </div>
      <Loading isLoading={isLoading} />
    </ContainerGrid>
  );
}
